//#region Libraries
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
//#endregion
//#region Components
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
//#endregion
//#region Icons
import AtIcon from "icons/AtIcon";
import PersonIcon from "icons/PersonIcon";
import SmileIcon from "icons/SmileIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useChangeRolesByCategory from "../../../../utils/hooks/useChangeRolesByCategory";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const 
    PROPS_CUSTOM_TEXT_INPUT = {
        minWidth: "unset",
        width: "180px"
    },
    PROPS_CUSTOM_SELECT = {
        width: {
            container: "160px",
            containerSelect: "100%"
        },
        minWidth: "160px"
    };
const Fields = ({
    isCreate,
    data: {
        categoryList,
        roleList
    },
    formData: {
        currentUser,
        form, 
        errors,
        errorText,
        isThereError
    },
    changeForm: {
        changeField,
        changeCategoryField,
        changeRoleField
    }
}) => {
    //#region Extra
    const { rolesByCategory } = useChangeRolesByCategory({
        currentUser,
        categoryId: form.category.id,
        roleList,
        changeRoleField
    });
    //#endregion
    return (
        <Column marginTop={errorText ? "5px" : "20px"} gap="20px">
            <ErrorMessage text={errorText} error={isThereError()}/>
            <Row justifyContent="flex-start" align="flex-start">
                <CustomTextInput
                    {...PROPS_CUSTOM_TEXT_INPUT}
                    label="Usuario:"
                    value={form.user}
                    placeholder="Escribe el usuario"
                    iconAdornment={<AtIcon/>}
                    error={errors.user}
                    onChange={value => changeField("user", value)}
                    maxLength={20}
                    disabled={!isCreate}/>
                <CustomTextInput
                    {...PROPS_CUSTOM_TEXT_INPUT}
                    label="Nombre:"
                    value={form.name}
                    placeholder="Escribe el nombre"
                    iconAdornment={<PersonIcon/>}
                    error={errors.name}
                    onChange={value => changeField("name", value)}
                    maxLength={35}/>
                <CustomTextInput
                    {...PROPS_CUSTOM_TEXT_INPUT}
                    label="Apellido:"
                    value={form.surname}
                    placeholder="Escribe el apellido"
                    iconAdornment={<SmileIcon/>}
                    error={errors.surname}
                    onChange={value => changeField("surname", value)}
                    maxLength={35}/>
                <CustomSelect 
                    {...PROPS_CUSTOM_SELECT}
                    label="Categoría:"
                    value={form.category.id}
                    error={errors.category}
                    defaultOptionText="Elige una categoría"
                    onChange={changeCategoryField}
                    optionsProps={getOptionsToCustomSelect(categoryList, { id: "id", text: "name" })}/>
                <CustomSelect 
                    {...PROPS_CUSTOM_SELECT}
                    label="Rol:"
                    value={form.role.id}
                    error={errors.role}
                    defaultOptionText="Elige un rol"
                    disabled={rolesByCategory.length < 2}
                    onChange={changeRoleField}
                    optionsProps={getOptionsToCustomSelect(rolesByCategory, { id: "id", text: "name" })}/>
            </Row>
        </Column>
    );
}

export default Fields;